import React from 'react'
import { Button } from '@mui/material'
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded'

type Props = {
    onRetry: () => void
    disabled?: boolean
}

export default function ChatRetryAction({ onRetry, disabled }: Props) {
    return (
        <Button
            size="small"
            variant="outlined"
            color="inherit"
            startIcon={<ReplayRoundedIcon sx={{ fontSize: 16 }} />}
            onClick={onRetry}
            disabled={disabled}
            sx={{
                mt: 1,
                alignSelf: 'flex-start',
                textTransform: 'none',
                fontSize: 12,
                py: 0.25,
                px: 1,
                borderColor: 'divider',
                color: 'text.secondary',
            }}
        >
            Retry
        </Button>
    )
}
